import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useId, useRef } from "react";
import { Box } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
export var ESlateBallotTab;
(function (ESlateBallotTab) {
    ESlateBallotTab["SLATES"] = "slates";
    ESlateBallotTab["CANDIDATES"] = "candidates";
})(ESlateBallotTab || (ESlateBallotTab = {}));
/**
 * Both panels stay mounted. The contests report their validation state from
 * effects, so unmounting them while the voter looks at the slates would lose
 * the checks that run before review.
 */
export var SlateBallotTabs = function (_a) {
    var value = _a.value, onChange = _a.onChange, slates = _a.slates, candidates = _a.candidates;
    var t = useTranslation().t;
    var theme = useTheme();
    var isPhone = useMediaQuery(theme.breakpoints.down("sm"));
    var id = useId();
    var tabId = function (tab) { return "".concat(id, "-tab-").concat(tab); };
    var panelId = function (tab) { return "".concat(id, "-panel-").concat(tab); };
    var containerRef = useRef(null);
    var isFirstRender = useRef(true);
    // A button inside a panel can switch tabs, which hides the button that
    // had focus. The focus then moves to the tab that became selected.
    useEffect(function () {
        var _a;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        var selected = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[role="tab"][aria-selected="true"]');
        if (selected && document.activeElement !== selected) {
            selected.focus();
        }
    }, [value]);
    var panels = [
        [ESlateBallotTab.SLATES, slates],
        [ESlateBallotTab.CANDIDATES, candidates],
    ];
    return (_jsxs(Box, { className: "slate-ballot-tabs-container", ref: containerRef, children: [_jsx(Box, { className: "slate-ballot-tabs-bar", sx: { borderBottom: 1, borderColor: "divider", marginBottom: "24px" }, children: _jsxs(Tabs, { className: "slate-ballot-tabs", variant: isPhone ? "fullWidth" : "standard", indicatorColor: "primary", textColor: "inherit", "aria-label": t("slates.tabs.label"), value: value, onChange: function (_event, next) { return onChange(next); }, children: [_jsx(Tab, { className: "slate-ballot-tab-slates", label: t("slates.tabs.slates"), value: ESlateBallotTab.SLATES, id: tabId(ESlateBallotTab.SLATES), "aria-controls": panelId(ESlateBallotTab.SLATES), sx: { minHeight: "44px", textTransform: "none" } }), _jsx(Tab, { className: "slate-ballot-tab-candidates", label: t("slates.tabs.candidates"), value: ESlateBallotTab.CANDIDATES, id: tabId(ESlateBallotTab.CANDIDATES), "aria-controls": panelId(ESlateBallotTab.CANDIDATES), sx: { minHeight: "44px", textTransform: "none" } })] }) }), panels.map(function (_a) {
                var tab = _a[0], content = _a[1];
                return (_jsx("div", { className: "slate-ballot-panel slate-ballot-panel-".concat(tab), role: "tabpanel", hidden: value !== tab, id: panelId(tab), "aria-labelledby": tabId(tab), children: content }, tab));
            })] }));
};
